import { render, staticRenderFns } from "./realTime.vue?vue&type=template&id=851903b2&scoped=true"
import script from "./realTime.vue?vue&type=script&lang=js"
export * from "./realTime.vue?vue&type=script&lang=js"
import style0 from "./realTime.vue?vue&type=style&index=0&id=851903b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851903b2",
  null
  
)

export default component.exports